{
	"transactionCardHeader": "Valida una transazione",
	"transactionCardDescriptionBold": "Vuoi validare una transazione per qualsiasi progetto?",
	"transactionCardDescriptionRegular": "Se hai a portata di mano un numero di transazione, puoi inserirlo qui e validare la transazione.",
	"showTransactionButton": "Mostra transazione",
	"transactionLabel": "Numero di transazione",
	"errors": {
		"transactionIdRequired": "Il numero di transazione è obbligatorio.",
		"transactionNotFound": "Transazione non trovata.",
		"transactionIdInvalid": "Numero di transazione non valido."
	}
}
